












































import { Component, Vue } from 'vue-property-decorator';

import authModule from '@/store/Auth';

import TrainingBanner from '@/components/dashboard/TrainingBanner.vue';
import SubscriptionBanner from '@/components/dashboard/SubscriptionBanner.vue';
import SubscriptionRequiredDialog from '@/components/common/SubscriptionRequiredDialog.vue';
import UpdatingDialog from '@/components/dashboard/UpdatingDialog.vue';
import EnableTotpDialog from '@/components/auth/EnableTotpDialog.vue';
import WelcomeDialog from '@/components/auth/WelcomeDialog.vue';
import TermsAndConditionsDialog from '@/components/auth/TermsAndConditionsDialog.vue';

import { OrganisationType } from '@/api';
import TermsAndConditionsBanner from '@/components/dashboard/TermsAndConditionsBanner.vue';

@Component({
  components: {
    TrainingBanner,
    SubscriptionBanner,
    SubscriptionRequiredDialog,
    UpdatingDialog,
    EnableTotpDialog,
    WelcomeDialog,
    TermsAndConditionsDialog,
    TermsAndConditionsBanner,
  },
})
export default class DashboardView extends Vue {
  dialogs = ['terms', 'welcome', 'totp', 'subscriptionRequired'];

  removeDialog(dialog: string) {
    this.dialogs = this.dialogs.filter(d => d !== dialog);
  }

  canShowDialog(dialog: string) {
    return this.dialogs.length && this.dialogs[0] === dialog;
  }

  get showTermsDialog() {
    return this.canShowDialog('terms');
  }

  get showWelcomeDialog() {
    return this.canShowDialog('welcome');
  }

  get showTotpDialog() {
    return (
      this.canShowDialog('totp') &&
      authModule.user &&
      authModule.user.tfaEnabled
    );
  }

  get showSubscriptionRequiredDialog() {
    return this.canShowDialog('subscriptionRequired');
  }

  get showUpdatingDialog() {
    return authModule.updatingDialog;
  }

  get canAccess() {
    if (this.isTrainingSession) {
      return this.isActive || !authModule.isUser;
    }
    return authModule.canAccessRoute;
  }

  get activeOrg() {
    return authModule.activeOrganisation;
  }

  get isRegular() {
    return (
      !!this.activeOrg &&
      this.activeOrg.organisation.orgType === OrganisationType.Regular
    );
  }

  get isTrainingSession() {
    return (
      !!this.activeOrg &&
      this.activeOrg.organisation.orgType === OrganisationType.TrainingSession
    );
  }

  get isTrainingProvider() {
    return (
      !!this.activeOrg &&
      this.activeOrg.organisation.orgType === OrganisationType.TrainingProvider
    );
  }

  get isActive() {
    return this.activeOrg && this.activeOrg.organisation.isActive;
  }

  get showSubscriptionBanner() {
    return (
      !this.isActive && !this.isTrainingProvider && !this.isTrainingSession
    );
  }

  get routeKey() {
    return authModule.dashboardRouteKey;
  }

  get updatingDialog() {
    return authModule.updatingDialog;
  }
}
